<template>
  <div>
    <header class="navbar navbar-header navbar-header-fixed">
      <a href="#" id="mainMenuOpen" class="burger-menu"
        ><svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-menu"
        >
          <line x1="3" y1="12" x2="21" y2="12"></line>
          <line x1="3" y1="6" x2="21" y2="6"></line>
          <line x1="3" y1="18" x2="21" y2="18"></line></svg
      ></a>
      <div class="navbar-brand">
        <a href="../../index.html" class="df-logo"
          ><img
            :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
            style="max-width: 40px"
        /></a>
      </div>
      <!-- navbar-brand -->
      <div id="navbarMenu" class="navbar-menu-wrapper">
        <div class="navbar-menu-header">
          <a href="../../index.html" class="df-logo"
            ><img :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
          /></a>
          <a id="mainMenuClose" href=""
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-x"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line></svg
          ></a>
        </div>
        <!-- navbar-menu-header -->
        <ul class="nav navbar-menu">
          <li class="nav-item">
            <a href="#" class="nav-link">
              <feather type="menu"></feather>
              Тээврийн автомашины дарааллын систем
            </a>
          </li>
        </ul>
      </div>
      <!-- navbar-menu-wrapper -->
      <div class="navbar-right"></div>
      <!-- navbar-right -->
    </header>
    <keep-alive :include="cacheList">
      <router-view>
        <slot name="content-header"></slot>
      </router-view>
    </keep-alive>
  </div>
</template>

<script>
import { hasOneOf } from "@/libs/tools";
import { request } from "@/api/all";
import { localRead } from "@/libs/util";

import CryptoJS from "crypto-js";

export default {
  name: "Main",
  components: {},
  data: () => ({
    myResBaseUrl: "https://res.gosmart.mn/",
    showHomePage: false,
    showLocalCompose: false,
    timer: ""
  }),
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },
  mounted() {
  },
  computed: {
    cacheList() {
      return ["ParentView", ...[]];
    }
  },
  methods: {
    makeid(length) {
      var result = [];
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result.push(
          characters.charAt(Math.floor(Math.random() * charactersLength))
        );
      }
      return result.join("");
    },
    encryptData(data) {
      CryptoJS.pad.NoPadding = { pad: function() {}, unpad: function() {} };
      let Pass = this.makeid(22);
      var text = data;
      var Salt = CryptoJS.enc.Utf8.parse("u2m9d2dfds1xS!2");
      var key128Bits1000Iterations = CryptoJS.PBKDF2(
        Pass.toString(CryptoJS.enc.Utf8),
        Salt,
        { keySize: 128 / 32, iterations: 1000 }
      );
      var iv = CryptoJS.enc.Hex.parse("e84ad660c4721ae0e84ad660c4721ae0");
      var encrypted = CryptoJS.AES.encrypt(text, key128Bits1000Iterations, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7
      });
      return Pass + encrypted;
    },
    hasPermission(arr) {
      if (this.$store.state.user.userId == "") return false;
      return hasOneOf(this.$store.state.user.userInfo.access, arr);
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
